import {
  Component,
  AfterContentInit,
  Input,
  Output,
  ContentChildren,
  EventEmitter,
  QueryList,
  TemplateRef,
} from '@angular/core';
import { FormStepDirective } from './directives/form-step/form-step.directive';

@Component({
  selector: 'app-wizard-form',
  templateUrl: './wizard-form.component.html',
  styleUrls: ['./wizard-form.component.scss'],
})
export class WizardFormComponent implements AfterContentInit {
  currentStep = 0;

  @Input() steps = [];

  @Output() nextAction = new EventEmitter<any>();

  @Output() finishAction = new EventEmitter<any>();

  @Output() stepChange = new EventEmitter<any>();

  @ContentChildren(TemplateRef) divElements: QueryList<TemplateRef<FormStepDirective>>;

  currentView: TemplateRef<any>;

  constructor() {
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handleBackStep = this.handleBackStep.bind(this);
  }

  renderForm() {
    this.currentView = this.divElements.toArray()[this.currentStep];
  }

  ngAfterContentInit() {
    this.renderForm();
  }

  handleNextStep() {
    if (this.isLastStep) {
      this.finishAction.emit();
      return;
    }

    this.currentStep++;
    this.nextAction.emit(this.currentStep);
    this.renderForm();
  }

  handleBackStep() {
    this.currentStep--;
    this.renderForm();
  }

  get isLastStep(): boolean {
    return this.currentStep === this.lastStepNumber;
  }

  get lastStepNumber(): number {
    return this.steps.length - 1;
  }
}
